module.exports = __webpack_public_path__ + "static/media/upParMeetKan.1a7ee271.jpg";